import { useState, useCallback } from 'react';
import { getConsumersApi } from '@/services/bolNotificationsApiClient';
import { ConsumerProofOfDelivery } from '@/api/bol-notifications';
import { useSnackbarNotification } from '@/hooks/useSnackbarNotification';

export interface UseConsumerProofOfDeliveryProps {
  subscriptionId: string;
  consumerId: string;
}

export interface UseConsumerProofOfDeliveryReturn {
  proofsOfDelivery: ConsumerProofOfDelivery[];
  loading: boolean;
  total: number;
  fetchProofsOfDelivery: (page?: number, pageSize?: number) => Promise<void>;
}

export const useConsumerProofOfDelivery = ({ 
  subscriptionId,
  consumerId 
}: UseConsumerProofOfDeliveryProps): UseConsumerProofOfDeliveryReturn => {
  const [proofsOfDelivery, setProofsOfDelivery] = useState<ConsumerProofOfDelivery[]>([]);
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  
  const { showError } = useSnackbarNotification();

  const fetchProofsOfDelivery = useCallback(async (page: number = 0, pageSize: number = 10) => {
    if (!subscriptionId || !consumerId) return;

    console.log('Fetching proofs of delivery with:', { subscriptionId, consumerId, page, pageSize });

    setLoading(true);
    
    try {
      const api = getConsumersApi();
      
      const response = await api.getConsumerProofsOfDelivery({
        subscriptionId,
        consumerId,
        limit: pageSize,
        offset: page * pageSize
      });
      
      console.log('Proofs of delivery API response:', response);
      
      setProofsOfDelivery(response.results);
      setTotal(response.pagination.total);
    } catch (err: unknown) {
      console.error('Error fetching proofs of delivery:', err);
      const errorMessage = err instanceof Error ? err.message : 'Failed to fetch proofs of delivery';
      showError(errorMessage);
    } finally {
      setLoading(false);
    }
  }, [subscriptionId, consumerId, showError]);

  return {
    proofsOfDelivery,
    loading,
    total,
    fetchProofsOfDelivery,
  };
};
